import { styled } from "@mui/material";
import * as React from "react";
import { PropsWithChildren } from "react";


interface IClassProps {
    disableMargins?: boolean;
}

interface IProps {
}

const Container = styled(
    "div",
    { shouldForwardProp: (propName: string) => propName != "disableMargins" }
)<IClassProps>(
    ({ theme, disableMargins }) => ({
        display: "flex",
        alignItems: "center",
        flexGrow: 1,
        marginBottom: disableMargins ? 0 : theme.spacing(1),
        marginTop: disableMargins ? 0 : theme.spacing(1),
    })
);

type Props = IProps & IClassProps & PropsWithChildren;

export const MprcFilterAdvancedContainer: React.FC<Props> = ({ children, ...rest }) => {
    return <Container {...rest}>{children}</Container>;
};
